import getUrlQueryParams from '@/utils/getUrlQueryParams';
import Cookies from 'js-cookie';
import getDomainName from './getDomainName';

function tryParseJSON(str) {
  try {
    return JSON.parse(decodeURIComponent(str));
  } catch {
    return null;
  }
}

export function getSavedAffiliateCode() {
  return Cookies.get('affiliate_code');
}

export function getSavedAffiliateCodeInArray() {
  if (tryParseJSON(Cookies.get('affiliate_code'))) {
    return tryParseJSON(Cookies.get('affiliate_code'));
  }

  return [Cookies.get('affiliate_code')];
}

export function saveAffiliateCode() {
  const { ref: affiliateQueryCode } = getUrlQueryParams(window.location.href);

  if (!affiliateQueryCode) {
    return;
  }

  const arrayCookies = [];

  let affiliateCookie = getSavedAffiliateCode();

  if (tryParseJSON(affiliateCookie)) {
    affiliateCookie = tryParseJSON(affiliateCookie);

    if (affiliateCookie.includes(affiliateQueryCode)) return;

    arrayCookies.push(...affiliateCookie, affiliateQueryCode);
  } else if (affiliateCookie && affiliateCookie !== affiliateQueryCode) {
    arrayCookies.push(affiliateCookie, affiliateQueryCode);
  } else {
    arrayCookies.push(affiliateCookie || affiliateQueryCode);
  }

  Cookies.set('affiliate_code', encodeURIComponent(JSON.stringify(arrayCookies)), {
    expires: 60,
    domain: process.env.NODE_ENV === 'production'
      ? `.${getDomainName(window.location.hostname)}`
      : '',
    raw: true,
  });
}
